import { combineReducers } from 'redux'

import { factoryReducer as createFactoryReducer, flattenStringMap } from '../../../reducers/utils'
import { actions, factoryActions } from '../constants'
import ui from './ui'
import data from './data'

export const DetailReducer = combineReducers({
  ui,
  data,
})

export const DetailReducerFactory = createFactoryReducer(
  {
    registerType: factoryActions.REGISTER,
    unregisterType: factoryActions.UNREGISTER,
    resetType: factoryActions.RESET,
  },
  flattenStringMap(actions),
  DetailReducer,
  (meta) => meta.ID,
)

export default createFactoryReducer(
  {
    registerType: factoryActions.REGISTER_TYPE,
    unregisterType: factoryActions.UNREGISTER_TYPE,
    resetType: factoryActions.RESET_TYPE,
  },
  [...flattenStringMap(actions), factoryActions.REGISTER, factoryActions.UNREGISTER, factoryActions.RESET],
  DetailReducerFactory,
  (meta) => meta.type,
)
